import React from 'react';
import { MessageLoading } from '../ui/message-loading';
import { TypewriterText } from '../ui/typewriter-text';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  showTypewriter?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md',
  message = 'Loading...',
  showTypewriter = false
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  return (
    <div className="flex flex-col items-center justify-center p-6">
      <div className={`${sizeClasses[size]} mb-2 text-accent-bright`}>
        <MessageLoading />
      </div>
      {message && !showTypewriter && (
        <p className="text-gray-text text-sm">{message}</p>
      )}
      {showTypewriter && (
        <div className="mt-2 text-sm">
          <TypewriterText />
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;